import {
  ComponentLoggingEventParams,
  PageParams,
  SDUIComponentInstanceRendererProps,
  SectionLoggingEventParams,
} from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIFilterRowRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRenderer";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton";
import { PersistStreamedServerComponentRenderer } from "@faire/retailer-visitor-shared/nextjs-rsc-util/PersistStreamedServerComponentRenderer";
import React from "react";

interface SDUIFilterRowRendererProps
  extends Omit<SDUIComponentInstanceRendererProps, "loggingData"> {
  formattedTotalResults?: string;
  sectionLoggingParams?: SectionLoggingEventParams;
  isFilterLoading?: boolean;
  loggingData?: ComponentLoggingEventParams;
  pageParams?: PageParams;
}

export const SDUIFilterRowRendererRSC: React.FC<SDUIFilterRowRendererProps> = (
  props
) => {
  return (
    <PersistStreamedServerComponentRenderer
      renderedComponentPromise={renderComponentOnServer(props)}
      loadingSkeleton={
        <SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton />
      }
      suspenseKey={`filter-row-${props.pageParams?.uniquePageKey}`}
    />
  );
};

const renderComponentOnServer = async ({
  component,
  sectionLoggingParams,
  isFilterLoading,
}: SDUIFilterRowRendererProps) => {
  return new Promise<React.ReactNode>((resolve) => {
    resolve(
      <SDUIFilterRowRenderer
        component={component}
        sectionLoggingParams={sectionLoggingParams}
        isFilterLoading={isFilterLoading}
      />
    );
  });
};
